import { createElement } from 'react';
import './index.scss';
import defaultImg from '../../assets/icon/mine/default.png';
import arrowImg from '../../assets/icon/mine/right.png';
const UserCard = ({ contentBg, headImg, userName, levelImg, isLogin, handleClick = (item) => { console.log(item); }, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const onTap = () => {
        if (handleClick) {
            handleClick(isLogin);
        }
    };
    return (createElement("div", { className: "user-info", ..._otherProps },
        contentBg
            ? (createElement("img", { className: "user-info-bg", src: contentBg, alt: "" }))
            : null,
        createElement("div", { className: "content", onClick: onTap },
            createElement("div", { className: "info-box" },
                headImg && isLogin
                    ? (createElement("img", { className: "head-img", src: headImg, alt: "" }))
                    : (createElement("img", { className: "head-img", src: defaultImg, alt: "" })),
                isLogin
                    ? (createElement("div", { className: "info" },
                        userName && createElement("div", { className: "user-name" }, userName),
                        levelImg && createElement("img", { className: "level", src: levelImg, alt: "" })))
                    : (createElement("div", { className: "no-login" }, "\u767B\u5F55/\u6CE8\u518C"))),
            createElement("img", { className: "arrow", src: arrowImg, alt: "" }))));
};
UserCard.displayName = 'UserCard';
export default UserCard;
